export function preParsePostFormat (string) {
    return string;
}



//////////////////
// WEBPACK FOOTER
// ./~/moment/src/lib/locale/pre-post-format.js
// module id = 260
// module chunks = 0